import React from 'react';
import { Link } from 'react-router-dom';
import { User } from 'lucide-react';

const ChatSidebar = ({ conversations, partnerId, online, wsConnected, onPick }) => (
  <div className={`bg-fnl-purple/60 rounded-2xl border border-purple-900/40 overflow-hidden flex flex-col ${partnerId ? 'hidden md:flex' : 'flex'}`}>
    <div className="px-5 py-4 border-b border-purple-900/40">
      <h2 className="text-white font-bold text-lg">Messages</h2>
      <p className="text-xs text-purple-300" data-testid="ws-status">
        {wsConnected ? 'Connected' : 'Connecting...'}
      </p>
    </div>
    <div className="flex-1 overflow-y-auto">
      {conversations.length === 0 ? (
        <div className="text-center text-purple-300 text-sm p-6">
          No conversations yet. Find someone to chat with from the{' '}
          <Link to="/browse" className="text-fnl-pink underline">Browse</Link> page.
        </div>
      ) : (
        conversations.map((c) => (
          <button
            key={c.partner_id}
            onClick={() => onPick(c.partner_id)}
            data-testid={`chat-convo-${c.partner_id}`}
            className={`w-full text-left px-4 py-3 flex items-center gap-3 hover:bg-fnl-pink/10 transition-colors border-b border-purple-900/30 ${partnerId === c.partner_id ? 'bg-fnl-pink/15' : ''}`}
          >
            <div className="w-12 h-12 rounded-full bg-fnl-pink/30 overflow-hidden flex items-center justify-center flex-shrink-0 relative">
              {c.partner_photo ? <img src={c.partner_photo} alt="" className="w-full h-full object-cover" /> : <User className="w-6 h-6 text-fnl-pink" />}
              {online.has(c.partner_id) && (
                <span className="absolute bottom-0 right-0 w-3 h-3 rounded-full bg-green-400 border-2 border-fnl-purple shadow-[0_0_6px_rgba(74,222,128,0.9)]" title="Online" />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between">
                <span className="text-white font-semibold truncate">{c.partner_name}</span>
                {c.unread > 0 && <span className="ml-2 text-[10px] bg-fnl-pink text-white px-2 py-0.5 rounded-full">{c.unread}</span>}
              </div>
              <p className="text-purple-300 text-xs truncate">{c.last_message}</p>
            </div>
          </button>
        ))
      )}
    </div>
  </div>
);

export default ChatSidebar;
